import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Componente para mostrar la información del header del lead (título, botones, cliente vinculado)
 */
const LeadStatusInfo = ({
    detallesLead,
    cargandoModal
}) => {
    if (cargandoModal || !detallesLead || !detallesLead.idLead) {
        return (
            <div className="w-100">
                <Row className="align-items-center mb-3">
                    <Col xs={12} lg={8} className="mb-2 mb-lg-0">
                        <div className="d-flex align-items-center gap-2">
                            <Skeleton circle width={24} height={24} />
                            <Skeleton width={150} height={24} />
                            <div className="d-flex align-items-center gap-2 ms-2 ps-2" style={{ borderLeft: '2px solid #e0e0e0' }}>
                                <Skeleton circle width={24} height={24} />
                                <Skeleton width={100} height={20} />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} lg={4}>
                        <div className="d-flex justify-content-lg-end">
                            <Skeleton width={180} height={24} />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    const getSourceInfo = (idSource) => {
        const sources = {
            1: { name: "WhatsApp", icon: "WhatsApp48.png", color: "#25D366" },
            2: { name: "Messenger", icon: "Messenger48.png", color: "#0084FF" },
            3: { name: "Facebook", icon: "Facebook48.png", color: "#1877F2" },
            4: { name: "Tawk", icon: "Tawk48.png", color: "#FFA500" },
            5: { name: "Correo", icon: "Correo48.png", color: "#EA4335" },
            6: { name: "AkasiaBot", icon: "AkasiaBot48.png", color: "#6C757D" },
            7: { name: "Distribuidor", icon: "Distribuidor48.png", color: "#0D6EFD" }
        };
        return sources[idSource] || { name: "---", icon: "", color: "#6C757D" };
    };

    const sourceInfo = getSourceInfo(detallesLead.idSource);

    const getDaysBadgeVariant = (days) => {
        if (days >= 0 && days < 3) return "success";
        if (days >= 3 && days < 5) return "warning";
        return "danger";
    };

    return (
        <div className="w-100">
            {/* Header principal */}
            <Row className="align-items-center mb-3">
                <Col xs={12} lg={8} className="mb-2 mb-lg-0">
                    <div className="d-flex align-items-center gap-2">
                        <FontAwesomeIcon
                            icon="headset"
                            className="text-primary"
                            size="lg"
                        />
                        <h5 className="mb-0 fw-bold text-dark">
                            Lead #{detallesLead.idLead}
                        </h5>
                        {detallesLead.idSource != 0 && (
                            <div className="d-flex align-items-center gap-2 ms-2 ps-2" style={{ borderLeft: '2px solid #e0e0e0' }}>
                                <img
                                    src={`/img/leads/${sourceInfo.icon}`}
                                    width={24}
                                    alt={sourceInfo.name}
                                    title={sourceInfo.name}
                                />
                                <Badge
                                    bg="light"
                                    text="dark"
                                    className="fs--2"
                                    style={{
                                        borderLeft: `3px solid ${sourceInfo.color}`,
                                        borderRadius: '4px'
                                    }}
                                >
                                    {sourceInfo.name}
                                </Badge>
                            </div>
                        )}
                    </div>
                </Col>
                <Col xs={12} lg={4}>
                    <div className="d-flex justify-content-lg-end align-items-center gap-2">
                        <SoftBadge
                            bg={getDaysBadgeVariant(detallesLead.iDaysDiff)}
                            className="d-flex align-items-center gap-1"
                        >
                            <FontAwesomeIcon icon="clock" size="xs" />
                            <span>{detallesLead.iDaysDiff} días sin actualizaciones</span>
                        </SoftBadge>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

LeadStatusInfo.propTypes = {
    detallesLead: PropTypes.shape({
        idLead: PropTypes.number,
        idSource: PropTypes.number,
        iDaysDiff: PropTypes.number,
        bRelease: PropTypes.bool,
        idUsuario: PropTypes.number,
        iDaysDiffOwner: PropTypes.number,
        idClienteAkasia: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        vNombreClienteAkasia: PropTypes.string
    }),
    cargandoModal: PropTypes.bool
};

export default LeadStatusInfo;
